export default function LabelDiv({ children }) {
    return (
        <div className="mt-3 mb-1" style={{ height: "20px", fontSize: "13px" }}>
            <div style={{
                position: "relative", top: "8.5px", left: "0px",
                right: "0px", background: "black", height: "0.5px"
            }}></div>
            <span style={{
                position: "absolute",
                background: "#fafafa",
                padding: "0px 0.25rem",
                zIndex: "2",
                marginLeft: "0.75rem"
            }}>{children}</span>
        </div>
    );
}
